import Button from '@mui/material/Button';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ReactElement, useState } from 'react';

import { formatLongDay, formatMonth } from '~/utils/date/date';
import { IArchivedMedicaidPlan, IMedicaidPlanClient } from '~/services/api/medicaidPlan/types';
import Modal from '~/ui/components/common/Modal';

import { ArchivedPlanEngagement } from '../PlanEngagement';
import formatArchivedBy from './helpers/formatArchivedBy';
import PlanField from './PlanField';

import styles from './MedicaidHistoryModal.module.scss';

interface IMedicaidHistoryModalProps {
  plan: IArchivedMedicaidPlan;
  client: IMedicaidPlanClient;
  onClose: () => void;
}

const MedicaidHistoryModal = ({
  plan,
  client,
  onClose,
}: IMedicaidHistoryModalProps): ReactElement => {
  const [isEngagementOpen, setIsEngagementOpen] = useState(false);

  return (
    <Modal open maxWidth={false} className={styles.paper} onClose={onClose}>
      <section className={styles.container}>
        <header className={styles.header}>
          <h2 className={styles.title}>Medicaid History</h2>
        </header>
        <div className={styles.content}>
          <div className={styles.fields}>
            <PlanField label="Medicaid Status">Inactive</PlanField>
            <PlanField label="Medicaid Type">{plan.medicaidType?.name}</PlanField>
            <PlanField label="Medicaid ID">{plan.medicaidId}</PlanField>
            <PlanField label="Effective Date">{formatMonth(plan.effectiveDate)}</PlanField>
            <PlanField label="Recertification Date">
              {formatMonth(plan.recertificationDate)}
            </PlanField>
            <PlanField label="Expiration Date">
              {plan.expirationDate && formatLongDay(plan.expirationDate)}
            </PlanField>
          </div>
          <p className={styles.archivedBy}>{formatArchivedBy(plan)}</p>
          {plan.hasCommunityEngagementHistory && (
            <div className={styles.engagement}>
              <Button
                color="primary"
                size="small"
                aria-expanded={isEngagementOpen}
                endIcon={isEngagementOpen ? <ExpandLess /> : <ExpandMore />}
                onClick={() => setIsEngagementOpen(value => !value)}
                className={styles.toggle}
              >
                View Community Engagement entries
              </Button>
              {isEngagementOpen && <ArchivedPlanEngagement plan={plan} client={client} />}
            </div>
          )}
        </div>
        <footer className={styles.actions}>
          <Button color="primary" variant="contained" onClick={onClose}>
            Close
          </Button>
        </footer>
      </section>
    </Modal>
  );
};

export default MedicaidHistoryModal;
